import { EnumsValues } from "../shared";

export const validPolicyNumber = (policyNumber: string): string => {
  return policyNumber.padStart(EnumsValues.MaxLengthInputs.PolizaNumber, "0");
};
